import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'large' | 'medium';
  isPurchaseButton?: boolean;
  onClick?: () => void;
}
export function CTAButton({
  children,
  variant = 'primary',
  size = 'large',
  isPurchaseButton = false,
  onClick
}: CTAButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl';
  const variantStyles = {
    primary: 'bg-amber-500 hover:bg-amber-600 text-gray-900 shadow-lg',
    secondary: 'bg-white hover:bg-gray-50 text-gray-900 border-2 border-amber-500'
  };
  const sizeStyles = {
    large: 'px-8 py-4 text-lg',
    medium: 'px-6 py-3 text-base'
  };
  // Si es el botón de compra, redirige a Shopify y dispara el pixel
  if (isPurchaseButton) {
    const handlePurchaseClick = () => {
      // Disparar el evento AddToCart en ambos pixels de Meta
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart');
      }
      if (onClick) {
        onClick();
      }
    };
    return <a href="https://www.rilumos.com/cart/51071448121665:1" target="_blank" rel="noopener noreferrer" onClick={handlePurchaseClick} className={`inline-block ${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]}`} data-id="element-5">
        {children}
      </a>;
  }
  // Si no es botón de compra, hace scroll a la sección de precio
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('precio');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
    if (onClick) {
      onClick();
    }
  };
  return <a href="#precio" onClick={handleClick} className={`inline-block ${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]}`} data-id="element-6">
      {children}
    </a>;
}